 
import React from 'react';

import PropTypes from 'prop-types';

import { UpcomingLiveTraining } from '@src/components/promoCards/layouts/OneThird/upcomingLiveTrainings';

export const SingleLiveTraining = (props) => {
    const {
        channel,
        description,
        slug,
        starts_at,
        title,
        states,
        products,
        updated_at: publishedAt,
    } = props;

    return (
        <UpcomingLiveTraining
            title={title}
            content={description}
            date={starts_at}
            link={{
                text: 'Click here',
                link: slug,
            }}
            agents={channel}
            states={states}
            products={products}
            publishedAt={publishedAt}
        />
    );
};

SingleLiveTraining.propTypes = {
    channel: PropTypes.any,
    description: PropTypes.any,
    slug: PropTypes.any,
    starts_at: PropTypes.any,
    title: PropTypes.any,
    states: PropTypes.array,
    products: PropTypes.array,
    updated_at: PropTypes.string,
};

export default SingleLiveTraining;
